import React from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import initHighcharts from './visualization/initHighcharts'

import LoadingSpinner from './LoadingSpinner';

import './HighchartWithLoadingSpinner.css'

// import highcharts modules; this must happen after imports
require('highcharts/modules/histogram-bellcurve')(Highcharts)


export default function HighchartWithLoadingSpinner(props) {
    initHighcharts();
    return (
        <div className="highchart-wrapper">
            {!props.loaded &&
                <LoadingSpinner />
            }
            {props.loaded && props.dataLength > 0 &&
                <HighchartsReact
                  highcharts={Highcharts}
                  options={props.options} />
            }
            {props.loaded && props.dataLength === 0 &&
                <div className="no-data">(No Data)</div>
            }
        </div>
    )
}
